import { LikeIcon } from '@beat-venues/ui/subset';
import type { CommonProps } from '../../types';
import { tv, type VariantProps } from 'tailwind-variants';

export interface LikeProps
    extends CommonProps,
        VariantProps<typeof LikeStyles> {
    onClick: (value: string, like: boolean) => void;
    id: string;
    liked: boolean;
}

export const LikeStyles = tv({
    slots: {
        heartWrapper:
            'group flex items-center justify-center focus h-8 w-8 rounded-full click-area-link focus-visible:rounded-full',
        icon: '',
    },
    variants: {
        liked: {
            true: {
                icon: 'stroke-ba-accent fill-ba-accent group-hover:fill-ba-accent',
            },
            false: {
                icon: 'fill-none stroke-white group-hover:fill-white',
            },
        },
    },
    defaultVariants: {
        liked: false,
    },
});

export const Like = ({
    className,
    onClick,
    id,
    liked,
    testId = 'like',
}: LikeProps): JSX.Element => {
    const { heartWrapper, icon } = LikeStyles({ liked });

    return (
        <div data-testid={testId} className={className}>
            <button
                className={heartWrapper()}
                onClick={() => {
                    onClick(id, !liked);
                }}
            >
                <LikeIcon className={icon()} size="lg" />
            </button>
        </div>
    );
};
